export class EnderecoDevedor {
  cep:String;
  cidade:String;
  uf:String;
  logradouro:String;
}
